module.exports = __webpack_public_path__ + "img/menu-logout.eb492730.svg";